'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MASK_STRING = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTextField = require('../cwtextfield/CwTextField');

var _CwTextField2 = _interopRequireDefault(_CwTextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MASK_STRING = exports.DEFAULT_MASK_STRING = 'ŔĒĀĆŤ';

var CwPasswordField = function (_React$Component) {
  (0, _inherits3.default)(CwPasswordField, _React$Component);

  function CwPasswordField() {
    (0, _classCallCheck3.default)(this, CwPasswordField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwPasswordField.__proto__ || (0, _getPrototypeOf2.default)(CwPasswordField)).call(this));

    _this.handleFocus = function (event) {
      event.target.select();
      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    };

    _this.handleBlur = function () {
      if (_this.props.value !== DEFAULT_MASK_STRING) {
        _this.setState({
          text: DEFAULT_MASK_STRING
        });
      }
      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    };

    _this.handleChange = function (value) {
      _this.setState({
        text: value
      });
      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    };

    _this.state = {
      text: DEFAULT_MASK_STRING
    };
    return _this;
  }

  (0, _createClass3.default)(CwPasswordField, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isNew && !this.props.value) {
        // IMPORTANT: unnecessary state update here causes infinite loop
        if (this.state.text !== '') {
          this.setState({
            text: ''
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_CwTextField2.default, (0, _assign2.default)({}, this.props, {
        value: this.state.text,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        type: 'password'
      }));
    }
  }]);
  return CwPasswordField;
}(_react2.default.Component);

CwPasswordField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Actual value of password field
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Callback function that is fired when textfield's text changes
   */
  onChange: _propTypes2.default.func,
  /**
   * Used to control order when tabbing through items
   */
  tabIndex: _propTypes2.default.number,
  /**
   * Used to control if text is valid
   */
  invalid: _propTypes2.default.bool,
  /**
   * Used to disable textfield
   */
  disabled: _propTypes2.default.bool,
  /**
   * Used as an identifier for the component
   */
  id: _propTypes2.default.string,
  /**
   * Callback function that is fired on key down
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * Used to control if passwordfield is autofocused when the page loads
   */
  autoFocus: _propTypes2.default.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  isNew: _propTypes2.default.bool
};

exports.default = CwPasswordField;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwpasswordfield/CwPasswordField.js
// module id = 844
// module chunks = 10